export default __webpack_public_path__ + "static/media/english-to-spanish-screenshot-04.d60daa5f.png";